/**
 * /app/trusts/$id/documents — Document vault (route shell).
 *
 * The screen body lives in `./documents-screen.tsx` and is lazy-loaded so the
 * upload modal + CSV export + register table leave the entry bundle (this is a
 * trust sub-tab, not a first-paint route). Same shell+screen pattern as
 * `./audit.tsx` / `./audit-screen.tsx`. This shell keeps the `Route` (so
 * routeTree.gen.ts's static import of `./documents` is unchanged) and the
 * search-param validator (it must run before the screen chunk loads).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/** Deep-link search params (feature backlog #40). A document deep-link such
 *  as `/app/trusts/$id/documents?filter=valuation` lands on the documents tab
 *  with the filename search pre-opened and pre-filled — so a notification /
 *  bell link can point a user straight at the document(s) it's about. The
 *  validator is intentionally permissive (non-string / absent → undefined) so
 *  a malformed query can never throw the route. */
function validateDocumentsSearch(
  search: Record<string, unknown>,
): { filter?: string } {
  const raw = search['filter'];
  if (typeof raw !== 'string') return {};
  const trimmed = raw.trim();
  if (trimmed.length === 0 || trimmed.length > 200) return {};
  return { filter: trimmed };
}

export const Route = createFileRoute('/app/trusts/$id/documents')({
  component: lazyRouteComponent(() => import('./documents-screen'), 'DocumentsScreen'),
  validateSearch: validateDocumentsSearch,
});
